import {randomInt} from '@/helpers/random.js'
import {ref} from 'vue'

/**
 * Simulated typing composable
 */
export function useSimulatedTyping(source) {

  //Refs
  const isTyping = ref(false)
  const typedOutput = ref('')

  //Start typing
  const startTyping = () => {
    isTyping.value = true
    typedOutput.value = ''
    typeNext()
  }

  //Type next character
  const typeNext = () => {
    if (typedOutput.value.length < source.value.length) {
      setTimeout(() => {
        typedOutput.value += source.value[typedOutput.value.length]
        typeNext()
      }, randomInt(5, 10))
    }
    else {
      isTyping.value = false
    }
  }

  //Expose interface
  return {
    isTyping,
    typedOutput,
    startTyping,
  }
}
